import { render } from "./LicenseDateView.vue?vue&type=template&id=346313a0"
import script from "./LicenseDateView.vue?vue&type=script&lang=js"
export * from "./LicenseDateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__